import styled from "styled-components";

export const LoginPageWrapper = styled.section`
  display: flex;
  height: 100vh;
  & > aside {
    display: flex;
    color: red;
    flex: 1 1 0;
    align-items: flex-end;
    @media (max-width: 50%) {
      display: none;
    }
  }
  & > aside > img {
    width: 100%;
    height: 100%;
  }
`;

export const LoginContentWrapper = styled.section`
  flex: 1 0;
  display: grid;
  place-items: center;
  & > div {
    display: flex;
    gap: 7rem;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 70%;
    max-width: 700px;
  }
`;

export const SideImage = styled.img`
  position: absolute;
  inset: 0 0 0 0;
  object-fit: cover;
  z-index: 1;
`;

export const OverlayTint = styled.div`
  background: linear-gradient(
    360deg,
    rgba(68, 14, 105, 0.87) 13%,
    rgba(34, 27, 60, 0.87) 50.67%
  );
  position: absolute;
  z-index: 10;
  inset: 0 0 0 0;
  opacity: 0.5;
  width: 100%;
  height: 100%;
`;

export const PhoneInput = styled.input`
  width: 100%;
  background-color: #edeff4;
  padding: 1.6rem 2rem 1.6rem 2rem;
  outline: none;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  color: ${(props) => props.theme.accentColor};
  letter-spacing: 2px;
`;

export const PhoneInputWrapper = styled.div`
  position: relative;
  /* margin: 8rem 0rem 12rem 0rem; */
  width: 500px;
  & > p {
    color: #4a4a4a;
    position: absolute;
    left: 2rem;
    z-index: 99;
    top: 50%;
    margin-top: 0.1rem;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 600;
    pointer-events: none;
    user-select: none;
  }
  & > div {
    width: 1px;
    height: 40%;
    margin-top: 0.1rem;
    background-color: #4a4a4a;
    z-index: 999;
    position: absolute;
    left: 6rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    user-select: none;
  }
`;

export const Error = styled.span`
  color: red;
  font-size: 1.4rem;
  z-index: 9;
  position: absolute;
  bottom: -3rem;
  left: 0;
`;
